import React from 'react';
// import hero from '../assets/ai-hero.png';

export default function Hero() {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <div className="hero-bg" />
      </div>

      <div className="max-w-7xl mx-auto px-4 py-16 grid md:grid-cols-2 gap-8 items-center">
        <div className="reveal">
          <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight">
            Upskill with <span className="text-brand-700 dark:text-brand-100">AI‑Powered</span> Skills for Every Role
          </h1>
          <p className="mt-4 text-lg text-slate-600 dark:text-slate-300">
            Personalized roadmap, mentors, and real projects — become job‑ready in 4–8 months.
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <a href= "#programs">Explore Programs</a>
            <a href="#audit" className="px-5 py-3 rounded-lg border hover:bg-slate-50-6 flex items-center gap-4 text-sm text-slate-600 dark:text-slate-300">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-slate-100 dark:bg-slate-800">⚡ AI‑guided learning</span>
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-slate-100 dark:bg-slate-800">👨‍🏫 1:1 Mentorship</span>
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-slate-100 dark:bg-slate-800">💼 Job Support</span>
            </a>
          </div>
        </div>
    </div>

        <div className="relative reveal">
          {/* <img src={hero} alt="Learners and AI interface" className="w-full rounded-2xl shadow-soft object-cover" /> */}
          <div className="absolute -bottom-6 left-6 md:left-10 bg-white dark:bg-slate-900 rounded-xl shadow-soft p-4 w-[85%] md:w-[70%]">
            <p className="text-sm text-slate-600 dark:text-slate-300">
              “Your personalized plan is ready: skills, projects & interview practice.”
            </p>
            <div className="mt-3 flex items-center justify-between">
              <span className="text-xs text-slate-500 dark:text-slate-400">Powered by AI</span>
                         <a href="#audit" className="text-brand-700"> dark  </a>  </div>
        </div>
      </div>
    </section>
  );
}
